import { Speaker } from '../speakers.page';

const AVATAR_COLORS = ['#22C55E', '#3B82F6', '#8B5CF6', '#F59E0B', '#EC4899'];

const DEPARTMENT_ORDER = [
  'Director',
  'ML Engineer',
  'Data analyst',
  'Data Analyst',
];

export type PositionTagStyle = { bg: string; color: string };

export const POSITION_TAG_COLORS: Record<string, PositionTagStyle> = {
  'ML Engineer': { bg: '#DCFCE7', color: '#15803D' },
  'Director': { bg: '#DBEAFE', color: '#1D4ED8' },
  'Data analyst': { bg: '#EDE9FE', color: '#6D28D9' },
  'Data Analyst': { bg: '#EDE9FE', color: '#6D28D9' },
};

const DEFAULT_TAG: PositionTagStyle = { bg: '#F3F4F6', color: '#4B5563' };

export type SpeakerGroup = {
  key: string;
  label: string;
  items: Speaker[];
};

export function getSpeakerInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }
  return (parts[0] || 'SP').slice(0, 2).toUpperCase();
}

export function getSpeakerAvatarColor(index: number): string {
  return AVATAR_COLORS[index % AVATAR_COLORS.length];
}

export function getWaveBarHeights(seed: string, count = 28): number[] {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash + seed.charCodeAt(i) * (i + 1)) % 9973;
  }
  return Array.from({ length: count }, (_, i) => {
    hash = (hash * 31 + i + 1) % 17;
    return 8 + hash;
  });
}

export function getPositionTagStyle(position: string): PositionTagStyle {
  if (!position || position === '—') return DEFAULT_TAG;
  return POSITION_TAG_COLORS[position] ?? DEFAULT_TAG;
}

export function normalizeDepartment(position: string): string {
  const trimmed = (position || '').trim();
  if (!trimmed || trimmed === '—') return 'other';
  const lower = trimmed.toLowerCase();
  if (lower === 'director') return 'Director';
  if (lower === 'ml engineer') return 'ML Engineer';
  if (lower === 'data analyst') return 'Data analyst';
  return trimmed;
}

export function groupSpeakersByDepartment(speakers: Speaker[]): SpeakerGroup[] {
  const map = new Map<string, Speaker[]>();

  speakers.forEach(speaker => {
    const key = normalizeDepartment(speaker.position);
    const list = map.get(key) ?? [];
    list.push(speaker);
    map.set(key, list);
  });

  const orderedKeys = [
    ...DEPARTMENT_ORDER.filter(k => map.has(k)),
    ...Array.from(map.keys()).filter(k => !DEPARTMENT_ORDER.includes(k) && k !== 'other').sort(),
    ...(map.has('other') ? ['other'] : []),
  ];

  return orderedKeys.map(key => ({
    key,
    label: key === 'other' ? 'Прочие' : key,
    items: map.get(key) ?? [],
  }));
}

export function formatPlaybackTime(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds < 0) return '0:00';
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}:${s.toString().padStart(2, '0')}`;
}
